var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_507)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3281 14.2453C16.8945 13.4984 16.25 11.3852 16.25 8.625C16.25 5.17322 13.4518 2.375 10 2.375C6.54822 2.375 3.75 5.17322 3.75 8.625C3.75 11.3859 3.10469 13.4984 2.67109 14.2453C2.44572 14.6318 2.44408 15.1092 2.6668 15.4973C2.88951 15.8853 3.30261 16.1247 3.75 16.125H6.93828C7.23556 17.5796 8.51529 18.6243 10 18.6243C11.4847 18.6243 12.7644 17.5796 13.0617 16.125H16.25C16.6972 16.1244 17.1101 15.8849 17.3326 15.4969C17.5551 15.109 17.5534 14.6317 17.3281 14.2453ZM10 17.375C9.20562 17.3748 8.49761 16.8739 8.23281 16.125H11.7672C11.5024 16.8739 10.7944 17.3748 10 17.375ZM3.75 14.875C4.35156 13.8406 5 11.4438 5 8.625C5 5.86358 7.23858 3.625 10 3.625C12.7614 3.625 15 5.86358 15 8.625C15 11.4414 15.6469 13.8383 16.25 14.875H3.75Z",
    fill: "#0D141C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellIcon);
export default __webpack_public_path__ + "static/media/notification_bell_icon.189ee9b1707a12015153ab1890aaa112.svg";
export { ForwardRef as ReactComponent };